export const measurementKeys = {
    all: ['measurements'] as const,
    lists: () => [...measurementKeys.all, 'list'] as const,
    list: (filters: string) => [...measurementKeys.lists(), { filters }] as const,
} as const;
